<template>
    <div>
        <span class="text-blue-600" :class="{'font-weight-bold': type === 'departure'}" v-if="stop">
            <span v-if="date">{{ date }}<br /></span>
            <span>{{ selectedStopTime ? selectedStopTime : '...' }}</span>
            {{ placeName }} - {{ stop.stopPoint.nameForClient }}
        </span>

        <v-select
            :options="setStopOptions(stops)"
            :reduce="name => name.key"
            label="name"
            class="stop-select d-inline-block"
            v-if="stops.length > 1"
            @input="selectStop($event)"
        >
            <template #open-indicator="{ attributes }">
                <span class="change-stop-label">{{ $t('airport_transfers.pages.change_stop') }}</span>
                <open-indicator class="open-indicator" v-bind="attributes"></open-indicator>
            </template>
        </v-select>
    </div>
</template>


<script>
    import OpenIndicator from '@components/OpenIndicator';

    export default {
        components: {
            OpenIndicator,
        },

        props: {
            selectedStop: {
                type: Object,
                required: true,
            },

            selectedStopTime: {
                type: String,
                required: false,
                default: null,
            },

            placeName: {
                type: String,
                required: true,
            },

            stops: {
                type: Array,
                required: true,
            },

            travel: {
                type: Object,
                required: true,
            },

            date: {
                type: String,
                required: false,
                default: null,
            },

            type: {
                type: String,
                required: true,
            },

            showDestinationAirport: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        data() {
            return {
                stop: this.selectedStop,
                stopTime: this.selectedStopTime,
            };
        },

        computed: {
            destinationAirport: function(){
                return this.travel.name;//@FIXME get correct value from api
                const matches = this.travel.name.match(/kurs pod lot (.*?)\)/);
                return matches.length>1?matches[1].replace(' Ryanair', ''):null;
            },
        },

        methods: {
            setStopOptions(stops) {
                let options = [];
                for (let i = 0; i < stops.length; i++) {
                    options.push({
                        time: stops[i].stopTime,
                        name: stops[i].stopPoint.nameForClient,
                        key: i,
                    });
                }

                return options;
            },

            selectStop(value) {
                this.stop = this.stops[value];

                this.$emit('input', {
                    type: this.type,
                    travel: this.travel,
                    stop: this.stop,
                });
            },
        },
    };
</script>


<style scoped>
    .v-select.stop-select >>> .vs__clear {
        display: none !important;
    }
    .v-select.stop-select >>> .vs__dropdown-menu {
        border-left: none;
        width: fit-content;
    }
    .v-select.stop-select >>> .vs__dropdown-toggle {
        border: none;
    }
    .v-select.stop-select >>> .vs__dropdown-toggle .vs__selected-options .vs__search::placeholder {
        color:#5f6a70;
    }
    .v-select.stop-select.is-filled:not(.vs--open) >>> .vs__search {
        height: 0;
        padding: 0;
    }

    .v-select.stop-select >>> .vs__selected-options {
        display: none;
    }

    .open-indicator {
        margin-left: 8px;
    }

    .change-stop-label {
        font-size: 0.9rem;
    }
</style>
